(function () {
    if (window.__browseLocationsHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.browseLocations = window.Branch.browseLocations || {};
    window.__browseLocationsHasFired = true;

    window.Branch.browseLocations.initBrowseLocationsPopup = function(showroomBrowseLocationsSection, parent, parentClassSelector){
        const dataScript = parent.querySelector('script.browse-locations-data[type="application/ld+json"]');

        console.log('dataScript', dataScript)

       if (!dataScript) {
         return;
       }

       let showroomData;
       try {
         showroomData = JSON.parse(dataScript.textContent);
       } catch (error) {
         console.error('Error parsing partner listing data:', error);
         return;
       }

        function resizeTileHeader() {
            console.log('resizeTileHeader called');
            const titleElements = document.querySelectorAll('.browse-locations-popup__location-title');

            if (titleElements.length === 0) return;

            titleElements.forEach(element => {
                element.style.removeProperty('height');
            });

            let maxHeight = 0;
            titleElements.forEach(element => {
                const height = element.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });

            titleElements.forEach(element => {
                element.style.height = `${maxHeight}px`;
            });
        }

       // Function to map state codes to full names
       function getStateName(stateCode) {
         const stateMap = {
           // US States
           'AL': 'Alabama',
           'AK': 'Alaska',
           'AZ': 'Arizona',
           'AR': 'Arkansas',
           'CA': 'California',
           'CO': 'Colorado',
           'CT': 'Connecticut',
           'DE': 'Delaware',
           'FL': 'Florida',
           'GA': 'Georgia',
           'HI': 'Hawaii',
           'ID': 'Idaho',
           'IL': 'Illinois',
           'IN': 'Indiana',
           'IA': 'Iowa',
           'KS': 'Kansas',
           'KY': 'Kentucky',
           'LA': 'Louisiana',
           'ME': 'Maine',
           'MD': 'Maryland',
           'MA': 'Massachusetts',
           'MI': 'Michigan',
           'MN': 'Minnesota',
           'MS': 'Mississippi',
           'MO': 'Missouri',
           'MT': 'Montana',
           'NE': 'Nebraska',
           'NV': 'Nevada',
           'NH': 'New Hampshire',
           'NJ': 'New Jersey',
           'NM': 'New Mexico',
           'NY': 'New York',
           'NC': 'North Carolina',
           'ND': 'North Dakota',
           'OH': 'Ohio',
           'OK': 'Oklahoma',
           'OR': 'Oregon',
           'PA': 'Pennsylvania',
           'RI': 'Rhode Island',
           'SC': 'South Carolina',
           'SD': 'South Dakota',
           'TN': 'Tennessee',
           'TX': 'Texas',
           'UT': 'Utah',
           'VT': 'Vermont',
           'VA': 'Virginia',
           'WA': 'Washington',
           'WV': 'West Virginia',
           'WI': 'Wisconsin',
           'WY': 'Wyoming',
           // Canadian Provinces/Territories
           'AB': 'Alberta',
           'BC': 'British Columbia',
           'MB': 'Manitoba',
           'NB': 'New Brunswick',
           'NL': 'Newfoundland and Labrador',
           'NS': 'Nova Scotia',
           'NT': 'Northwest Territories',
           'NU': 'Nunavut',
           'ON': 'Ontario',
           'PE': 'Prince Edward Island',
           'QC': 'Quebec',
           'SK': 'Saskatchewan',
           'YT': 'Yukon',
           // Fallback for full names already provided
           'Ontario': 'Ontario'
         };
         return stateMap[stateCode] || stateCode;
       }

       // Function to build dropdown options HTML for custom dropdown, organized by state
       function buildDropdownOptions(currentHandle, showroomData) {
        console.log('showroomData', showroomData);

         // Group locations by state
         const locationsByState = {};
         for (const handle in showroomData) {
           const state = showroomData[handle].state;
           const stateName = getStateName(state);

           if (!locationsByState[stateName]) {
             locationsByState[stateName] = [];
           }

           locationsByState[stateName].push({
             handle: handle,
             title: showroomData[handle].title,
             type: showroomData[handle].type,
             tooltipText: showroomData[handle].tooltipText
           });
         }

         // Sort states alphabetically
         const sortedStates = Object.keys(locationsByState).sort();

         // Build HTML with headers and grouped options
         let optionsHTML = '';
         sortedStates.forEach(stateName => {
           // Add state header
           optionsHTML += `<div class="browse-locations-popup__option-header">${stateName}</div>`;

           // Add locations for this state
           locationsByState[stateName].forEach(location => {
             const selected = location.handle === currentHandle ? 'data-selected="true"' : '';
             console.log('location', location.type);
             const tooltipText = location.tooltipText ? location.tooltipText.toLowerCase().replace(/\b\w/g, char => char.toUpperCase()) : '';
             const title = location.type == 'showroom' ? tooltipText != '' ? `Branch (${tooltipText})` : `Branch (Showroom)` : `${location.title} (Partner)`;
             optionsHTML += `<div class="browse-locations-popup__option" data-value="${location.handle}" ${selected}>${title}</div>`;
           });
         });

         return optionsHTML;
       }

       // Function to get display name for current handle
       function getDisplayName(handle, showroomData) {
         return showroomData[handle] ? showroomData[handle].title : handle.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ').replaceAll('Nyc', 'NYC');
       }

       // Function to build location content
       function buildLocationContent(handle, showroomData) {
         let data = showroomData[handle];
         if(handle == 'virtual-tour'){
            data = {"type": "showroom", "text": "", "maps_link": "", "appointment_link": "https://calendly.com/branchfurniture/virtual-appointment"};
         }

         if (!data) {
           console.error('No data found for handle:', handle);
           return '<p>No location data available.</p>';
         }

         // Decode URL-encoded strings
         const address = handle == 'virtual-tour' ? '' : decodeURIComponent(data.address.replace(/\+/g, ' '));
         const text = handle == 'virtual-tour' ? '<div class="metafield-rich_text_field"><p>Schedule a virtual tour with one of our experts to get your questions answered without leaving the comfort of your home!</p><p>We can answer questions about the entire Branch line of products including chairs, desks, accessories, workplace collections, and more.</p></div>' : decodeURIComponent(data.text.replace(/\+/g, ' '));

         return `
         <div class="browse-locations-popup__address">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="22" viewBox="0 0 15 22" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 0C3.35357 0 0 3.443 0 7.7C0 13.475 7.5 22 7.5 22C7.5 22 15 13.475 15 7.7C15 3.443 11.6464 0 7.5 0ZM7.50005 10.4494C6.02147 10.4494 4.82147 9.21746 4.82147 7.69949C4.82147 6.18153 6.02147 4.94956 7.50005 4.94956C8.97862 4.94956 10.1786 6.18153 10.1786 7.69949C10.1786 9.21746 8.97862 10.4494 7.50005 10.4494Z" fill="#314438"/>
              </svg>
           ${handle != 'virtual-tour' ? `
             <a href="${data.maps_link}" target="_blank" rel="noopener noreferrer">${address}</a>
           ` : `<span>Online</span>` }
           </div>
           <div class="browse-locations-popup__description">
             ${text}
           </div>
           <div class="browse-locations-popup__cta btn">
             <a href="${data.type == 'showroom' && data.appointment_link != '' ? data.appointment_link : data.maps_link}" target="_blank" rel="noopener noreferrer">${data.type == 'showroom' && data.appointment_link != '' ? 'Book a tour' : 'Take me there'}</a>
           </div>
         `;
       }

       // Function to update popup content
       function updatePopupContent(handle, showroomData) {
         const contentContainer = document.querySelector('.browse-locations-popup__content-dynamic');
         if (contentContainer) {
           contentContainer.innerHTML = buildLocationContent(handle, showroomData);
         }

         // Show dropdown when displaying individual location
         const dropdown = document.querySelector('.browse-locations-popup__dropdown');
         if (dropdown) {
           dropdown.style.display = 'flex';
         }

         // Hide ZIP search when showing dropdown selection
         const zipSearch = document.querySelector('.browse-locations-popup__zip-search');
         if (zipSearch) {
            zipSearch.style.display = 'none';
            zipSearch.style.justifyContent = '';
            zipSearch.querySelector('.browse-locations-popup__label').style.display = 'block';
            zipSearch.querySelector('.browse-locations-popup__zip-input-container').style.justifyContent = '';
         }

         // Clear ZIP input when showing dropdown selection
         const zipInput = document.querySelector('.browse-locations-popup__zip-input');
         const zipError = document.querySelector('.browse-locations-popup__zip-error');
         if (zipInput) {
           zipInput.value = '';
         }
         if (zipError) {
           zipError.style.display = 'none';
         }

         // Show back button (not in default state)
         const backButton = document.querySelector('.browse-locations-popup__back-to-list');
         if (backButton) {
           backButton.style.display = 'block';
           backButton.setAttribute('data-current-type', 'dropdown')
         }
       }

       // Function to get coordinates from ZIP code
       async function getCoordinatesFromZip(zipCode) {
         try {
           // Clean the ZIP code (remove spaces, handle Canadian format)
           const cleanZip = zipCode.trim().replace(/\s+/g, '');

           // Try US ZIP code first
           let response = await fetch(`https://api.zippopotam.us/us/${cleanZip}`);

           // If US fails, try Canada
           if (!response.ok) {
              const cleanZipCan = cleanZip.substring(0,3);
              response = await fetch(`https://api.zippopotam.us/ca/${cleanZipCan}`);
           }

           if (!response.ok) {
             return null;
           }

           const data = await response.json();

           if (data && data.places && data.places.length > 0) {
             return {
               latitude: parseFloat(data.places[0].latitude),
               longitude: parseFloat(data.places[0].longitude)
             };
           } else {
             return null;
           }
         } catch (error) {
           console.error('Error fetching coordinates:', error);
           return null;
         }
       }

       // Function to calculate distance in miles between two coordinates
       function getDistanceMiles(lat1, lon1, lat2, lon2) {
         const R = 3958.8; // Earth's radius in miles
         const toRad = (deg) => deg * Math.PI / 180;

         const dLat = toRad(lat2 - lat1);
         const dLon = toRad(lon2 - lon1);

         const a =
           Math.sin(dLat / 2) ** 2 +
           Math.cos(toRad(lat1)) *
           Math.cos(toRad(lat2)) *
           Math.sin(dLon / 2) ** 2;

         const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

         return R * c;
       }

       // Function to find nearest locations (returns top 5)
       function findNearestLocations(zipLat, zipLon, showroomData, count = 5) {
         const locations = [];

         for (const handle in showroomData) {
           const location = showroomData[handle];
           if (location.latitude && location.longitude) {
             const distance = getDistanceMiles(
               zipLat,
               zipLon,
               parseFloat(location.latitude),
               parseFloat(location.longitude)
             );

             locations.push({
               handle: handle,
               distance: distance,
               data: location
             });
           }
         }

         // Sort by distance and return top N
         locations.sort((a, b) => a.distance - b.distance);
         return locations.slice(0, count);
       }

       // Function to build locations carousel
       function buildLocationsCarousel(locations, showroomData) {
         if (!locations || locations.length === 0) {
           return '<p style="text-align: center; color: #888;">No locations found.</p>';
         }

         let slidesHTML = '';
         locations.forEach(location => {
           const data = location.data;
           const handle = location.handle;
           const distance = location.distance;

           // Decode URL-encoded strings
           const address = decodeURIComponent(data.address.replace(/\+/g, ' '));
           const imageUrl = data.store_main_image || '//via.placeholder.com/300x200';
           const title = data.title || getDisplayName(handle, showroomData);
           const distanceText = `${distance.toFixed(1)} miles away`;
           let tooltipText = data.tooltipText;

           slidesHTML += `
             <div class="browse-locations-popup__location-slide swiper-slide" data-handle="${handle}">
               <div class="browse-locations-popup__location-image-container">
                 <img src="${imageUrl}" alt="${title}" loading="lazy" class="browse-locations-popup__location-image">
               </div>
               <div class="browse-locations-popup__location-info">
                 <h4 class="browse-locations-popup__location-title">${title}</h4>
                 <div data-type="${tooltipText.toLowerCase().replaceAll(' ', '')}" class="browse-locations-popup__location-tooltip">
                 <svg xmlns="http://www.w3.org/2000/svg" width="5" height="7" viewBox="0 0 5 7" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.19565 0C0.98177 0 0 0.98177 0 2.19565C0 3.84239 2.19565 6.27329 2.19565 6.27329C2.19565 6.27329 4.3913 3.84239 4.3913 2.19565C4.3913 0.98177 3.40953 0 2.19565 0ZM2.19565 2.97978C1.7628 2.97978 1.41149 2.62848 1.41149 2.19563C1.41149 1.76279 1.7628 1.41149 2.19565 1.41149C2.62851 1.41149 2.97981 1.76279 2.97981 2.19563C2.97981 2.62848 2.62851 2.97978 2.19565 2.97978Z" fill="white"/>
                </svg>
                <span>${tooltipText}</span></div>
                <p class="browse-locations-popup__location-distance"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.303 4.251L4.6973 9.68585L10.0001 10.2293V15.6642L15.303 4.251Z" fill="#314438"></path><path d="M15.0658 3.76505C15.2682 3.6613 15.5131 3.70025 15.6747 3.86271C15.8363 4.02518 15.8788 4.27527 15.7814 4.48475L10.4786 15.8979C10.372 16.1273 10.1248 16.2501 9.88306 16.1941C9.64145 16.138 9.46982 15.9183 9.46982 15.6644V10.72L4.64445 10.2264C4.40965 10.2023 4.21809 10.0226 4.17527 9.78478C4.13254 9.5468 4.24892 9.30812 4.46009 9.1999L15.0658 3.76505ZM6.57294 9.33259L10.0529 9.68925C10.324 9.71708 10.5304 9.95037 10.5304 10.2295V13.2591L14.1616 5.44327L6.57294 9.33259Z" fill="#314438"></path></svg>${distanceText}</p>
               </div>
             </div>
           `;
         });

         return `
           <div class="browse-locations-popup__locations-carousel-outer">
             <div class="browse-locations-popup__locations-carousel swiper">
               <div class="browse-locations-popup__locations-wrapper swiper-wrapper">
                 ${slidesHTML}
               </div>
             </div>
             <div class="browse-locations-popup__locations-nav-left swiper-button-prev">
               <svg aria-hidden="false" tabindex="-1" role="presentation" class="icon icon-chevron" viewBox="0 0 32 32">
                 <path fill="#314438" fill-rule="evenodd" clip-rule="evenodd" d="M21.1199 16L7 1.93279L8.94004 0L25 16L8.94004 32L7 30.0672L21.1199 16Z"></path>
               </svg>
             </div>
             <div class="browse-locations-popup__locations-nav-right swiper-button-next">
               <svg aria-hidden="false" tabindex="-1" role="presentation" class="icon icon-chevron" viewBox="0 0 32 32">
                 <path fill="#314438" fill-rule="evenodd" clip-rule="evenodd" d="M21.1199 16L7 1.93279L8.94004 0L25 16L8.94004 32L7 30.0672L21.1199 16Z"></path>
               </svg>
             </div>
           </div>
         `;
       }

       // Store swiper instance for locations carousel
       let locationsSwiper = null;

       // Function to initialize locations swiper
       function initLocationsSwiper() {
         const swiperElement = document.querySelector('.browse-locations-popup__locations-carousel.swiper');

         // Destroy existing swiper instance if it exists
         if (locationsSwiper && locationsSwiper.destroy) {
           locationsSwiper.destroy(true, true);
           locationsSwiper = null;
         }

         if (swiperElement && typeof Swiper !== 'undefined') {
           locationsSwiper = new Swiper('.browse-locations-popup__locations-carousel', {
                slidesPerView: 1,
                spaceBetween: 12,
                slideToClickedSlide: false,
                preventClicks: false,
                preventClicksPropagation: false,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: `.browse-locations-popup__locations-nav-right`,
                    prevEl: `.browse-locations-popup__locations-nav-left`,
                },
                breakpoints: {
                500: {
                    slidesPerView: 1.25,
                    spaceBetween: 12
                },
                700: {
                    slidesPerView: 2.25,
                    spaceBetween: 20
                }
                },
                on: {
                    click: function(swiper, event) {
                        event.stopPropagation();
                    }
                }
           });

           // Add click handlers to slides to show location details
           const slides = swiperElement.querySelectorAll('.browse-locations-popup__location-slide');
           slides.forEach(slide => {
             slide.addEventListener('click', function() {
               const handle = this.getAttribute('data-handle');
               if (handle) {
                 // Update the dropdown selection
                 window.Branch.showroomBrowseLocations.selectedHandle = handle;
                 const selectTrigger = document.querySelector('.browse-locations-popup__select-trigger');
                 if (selectTrigger) {
                   const displayName = getDisplayName(handle, window.Branch.showroomBrowseLocations.currentShowroomData);
                   selectTrigger.querySelector('span').textContent = displayName;
                   selectTrigger.setAttribute('data-current-value', handle);
                 }

                 // Update selected state in dropdown
                 const allOptions = document.querySelectorAll('.browse-locations-popup__option');
                 allOptions.forEach(opt => opt.removeAttribute('data-selected'));
                 const selectedOption = document.querySelector(`.browse-locations-popup__option[data-value="${handle}"]`);
                 if (selectedOption) {
                   selectedOption.setAttribute('data-selected', 'true');
                 }

                 // Update content (this will also clear ZIP input)
                 updatePopupContent(handle, window.Branch.showroomBrowseLocations.currentShowroomData);
               }
             });
           });
         }
         resizeTileHeader(parent);
       }

       function buildPopupContent(currentHandle, showroomData) {
        return `
           <div class="browse-locations-popup__inner" style="max-width: 622px; margin: 0 auto;">
             <button class="browse-locations-popup__close" aria-label="Close">
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20" fill="#314438"></path></svg>
             </button>
             <div class="browse-locations-popup__header">
               <h2>Find a Branch Location</h2>
               <div class="browse-locations-popup__dropdown">
                <label class="browse-locations-popup__label">
                    Choose a location
                </label>
                <div class="browse-locations-popup__custom-select">
                  <div class="browse-locations-popup__select-trigger" data-current-value="${currentHandle}">
                    <span>${currentHandle ? getDisplayName(currentHandle, showroomData) : 'Location'}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M5 6L0.669872 1.5L9.33013 1.5L5 6Z" fill="#314438"/>
                    </svg>
                  </div>
                  <div class="browse-locations-popup__options">
                    ${buildDropdownOptions(currentHandle, showroomData)}
                    <div class="browse-locations-popup__option" data-value="virtual-tour">
                        Virtual Tour
                    </div>
                  </div>
                </div>
               </div>
               <div class="browse-locations-popup__zip-search">
                <label class="browse-locations-popup__label">
                    or enter your ZIP code
                </label>
                <div class="browse-locations-popup__zip-input-container">
                  <input type="text" class="browse-locations-popup__zip-input" placeholder="ZIP code" maxlength="10">
                  <button class="browse-locations-popup__zip-button">Search</button>
                </div>  
               </div>
               <div class="browse-locations-popup__zip-error" style="display: none;"></div>
             </div>
             <div class="browse-locations-popup__content-dynamic">
             ${currentHandle ? buildLocationContent(currentHandle, showroomData) : '<p style="text-align: center; color: #888; display: none;">Please select a location to view details.</p>'}
             </div>
            <button class="browse-locations-popup__back-to-list btn" style="display: ${currentHandle ? 'block' : 'none'};">
               Back
            </button>
           </div>
         `;
       }

           const cta = showroomBrowseLocationsSection.querySelector(`a.${parentClassSelector}__btn`);

           if (cta) {
             cta.addEventListener('click', function(e) {
               e.preventDefault();
               e.stopPropagation();
               let currentHandle = '';

               // Close any existing browse-locations popup before opening a new one
               const existingModal = document.querySelector('.tingle-modal.browse-locations-popup');
               if (existingModal && existingModal.classList.contains('tingle-modal--visible')) {
                 const existingCloseBtn = existingModal.querySelector('.tingle-modal__close');
                 if (existingCloseBtn) {
                   existingCloseBtn.click();
                 }
               }

               // Store showroomData globally for carousel click handlers
               window.Branch.showroomBrowseLocations.currentShowroomData = showroomData;

               // Build popup content
               const content = buildPopupContent(currentHandle, showroomData);

               // Use Simplistic.openModal to open the popup
               if (window.Simplistic && window.Simplistic.openModal) {
                 window.Simplistic.openModal(content, 'browse-locations-popup', 'browse-locations', $(cta));

                 // Initialize dropdown after modal is opened
                 setTimeout(() => {
                   // Add close button event listener
                   const closeButton = document.querySelector('.browse-locations-popup__close');
                   if (closeButton) {
                     closeButton.addEventListener('click', function() {
                       // Close the tingle modal
                       const modal = document.querySelector('.tingle-modal');
                       if (modal && modal.classList.contains('tingle-modal--visible')) {
                         const closeBtn = modal.querySelector('.tingle-modal__close');
                         if (closeBtn) {
                           closeBtn.click();
                         }
                       }
                     });
                   }

                   // Add back to list button event listener
                   const backToListButton = document.querySelector('.browse-locations-popup__back-to-list');
                   if (backToListButton) {
                     backToListButton.addEventListener('click', function() {
                       // Reset to default state (same as clicking state header)
                       window.Branch.showroomBrowseLocations.selectedHandle = '';

                       // Reset trigger text to placeholder
                       const selectTrigger = document.querySelector('.browse-locations-popup__select-trigger');
                       if (selectTrigger) {
                         selectTrigger.querySelector('span').textContent = 'Location';
                         selectTrigger.setAttribute('data-current-value', '');
                       }

                       // Remove selected state from all options
                       const allOptions = document.querySelectorAll('.browse-locations-popup__option');
                       allOptions.forEach(opt => opt.removeAttribute('data-selected'));

                       // Reset content to placeholder
                       const contentContainer = document.querySelector('.browse-locations-popup__content-dynamic');
                       if (contentContainer) {
                         contentContainer.innerHTML = '<p style="text-align: center; color: #888; display: none;">Please select a location to view details.</p>';
                       }

                       // Show dropdown
                       const dropdown = document.querySelector('.browse-locations-popup__dropdown');
                       if (dropdown) {
                         dropdown.style.display = 'flex';
                       }

                       // Show ZIP search section in default state
                       const zipSearch = document.querySelector('.browse-locations-popup__zip-search');
                       if (zipSearch) {
                         zipSearch.style.display = 'flex';
                         zipSearch.style.justifyContent = '';
                         zipSearch.querySelector('.browse-locations-popup__label').style.display = 'block';
                         zipSearch.querySelector('.browse-locations-popup__zip-input-container').style.justifyContent = '';
                       }

                       // Clear ZIP input and error
                       const zipInput = document.querySelector('.browse-locations-popup__zip-input');
                       const zipError = document.querySelector('.browse-locations-popup__zip-error');
                       if (zipInput) {
                         zipInput.value = '';
                       }
                       if (zipError) {
                         zipError.style.display = 'none';
                       }

                       // Hide back button (in default state)
                       backToListButton.style.display = 'none';
                        backToListButton.setAttribute('data-current-type', 'neither')

                     });
                   }

                   // Add event listeners to custom dropdown
                   const selectTrigger = document.querySelector('.browse-locations-popup__select-trigger');
                   const customSelect = document.querySelector('.browse-locations-popup__custom-select');
                   const optionsContainer = document.querySelector('.browse-locations-popup__options');

                   if (selectTrigger && customSelect && optionsContainer) {
                     // Toggle dropdown open/close
                     selectTrigger.addEventListener('click', function(e) {
                       e.stopPropagation();
                       customSelect.classList.toggle('is-open');
                     });

                     // Handle option header clicks to reset selection
                     const headers = optionsContainer.querySelectorAll('.browse-locations-popup__option-header');
                     headers.forEach(header => {
                       header.addEventListener('click', function(e) {
                         e.stopPropagation();

                         // Clear selection
                         window.Branch.showroomBrowseLocations.selectedHandle = '';

                         // Reset trigger text to placeholder
                         selectTrigger.querySelector('span').textContent = 'Location';
                         selectTrigger.setAttribute('data-current-value', '');

                         // Remove selected state from all options
                         const allOptions = optionsContainer.querySelectorAll('.browse-locations-popup__option');
                         allOptions.forEach(opt => opt.removeAttribute('data-selected'));

                         // Close dropdown
                         customSelect.classList.remove('is-open');

                         // Reset content to placeholder
                         const contentContainer = document.querySelector('.browse-locations-popup__content-dynamic');
                         if (contentContainer) {
                           contentContainer.innerHTML = '<p style="text-align: center; color: #888; display: none;">Please select a location to view details.</p>';
                         }

                         // Show dropdown and clear ZIP input
                         const dropdown = document.querySelector('.browse-locations-popup__dropdown');
                         if (dropdown) {
                           dropdown.style.display = 'flex';
                         }

                         // Show ZIP search section
                         const zipSearch = document.querySelector('.browse-locations-popup__zip-search');
                         if (zipSearch) {
                            zipSearch.style.display = 'flex';
                            zipSearch.style.justifyContent = '';
                            zipSearch.querySelector('.browse-locations-popup__label').style.display = 'block';
                            zipSearch.querySelector('.browse-locations-popup__zip-input-container').style.justifyContent = '';
                         }

                         const zipInput = document.querySelector('.browse-locations-popup__zip-input');
                         const zipError = document.querySelector('.browse-locations-popup__zip-error');
                         if (zipInput) {
                           zipInput.value = '';
                         }
                         if (zipError) {
                           zipError.style.display = 'none';
                         }

                         // Hide back button (in default state)
                         const backButton = document.querySelector('.browse-locations-popup__back-to-list');
                         if (backButton) {
                           backButton.style.display = 'none';
                            backButton.setAttribute('data-current-type', 'neither')
                         }
                       });
                     });

                     // Handle option selection
                     const options = optionsContainer.querySelectorAll('.browse-locations-popup__option');
                     options.forEach(option => {
                       option.addEventListener('click', function(e) {
                         e.stopPropagation();
                         window.Branch.showroomBrowseLocations.selectedHandle = this.getAttribute('data-value');
                         const displayName = this.textContent;

                         // Update trigger text and value
                         selectTrigger.querySelector('span').textContent = displayName;
                         selectTrigger.setAttribute('data-current-value', window.Branch.showroomBrowseLocations.selectedHandle);

                         // Update selected state
                         options.forEach(opt => opt.removeAttribute('data-selected'));
                         this.setAttribute('data-selected', 'true');

                         // Close dropdown
                         customSelect.classList.remove('is-open');

                         // Update content based on selection
                         updatePopupContent(window.Branch.showroomBrowseLocations.selectedHandle, showroomData);
                         console.log('Selected location:', window.Branch.showroomBrowseLocations.selectedHandle);
                       });
                     });

                     // Close dropdown when clicking outside
                     document.addEventListener('click', function closeDropdown(e) {
                       if (!customSelect.contains(e.target)) {
                         customSelect.classList.remove('is-open');
                       }
                     });
                   }

                   // Handle ZIP code search
                   const zipInput = document.querySelector('.browse-locations-popup__zip-input');
                   const zipButton = document.querySelector('.browse-locations-popup__zip-button');
                   const zipError = document.querySelector('.browse-locations-popup__zip-error');

                   if (zipInput && zipButton && zipError) {
                     const handleZipSearch = async function() {
                       const zipCode = zipInput.value.trim();

                       if (!zipCode) {
                         // Reset to initial state
                         const contentContainer = document.querySelector('.browse-locations-popup__content-dynamic');
                         if (contentContainer) {
                           contentContainer.innerHTML = '<p style="text-align: center; color: #888; display: none;">Please select a location to view details.</p>';
                         }

                         // Show dropdown again
                         const dropdown = document.querySelector('.browse-locations-popup__dropdown');
                         if (dropdown) {
                           dropdown.style.display = 'flex';
                         }

                         // Show ZIP search section
                         const zipSearch = document.querySelector('.browse-locations-popup__zip-search');
                         if (zipSearch) {
                            zipSearch.style.display = 'flex';
                            zipSearch.style.justifyContent = '';
                            zipSearch.querySelector('.browse-locations-popup__label').style.display = 'block';
                            zipSearch.querySelector('.browse-locations-popup__zip-input-container').style.justifyContent = '';
                         }

                         // Clear dropdown selection
                         window.Branch.showroomBrowseLocations.selectedHandle = '';
                         if (selectTrigger) {
                           selectTrigger.querySelector('span').textContent = 'Location';
                           selectTrigger.setAttribute('data-current-value', '');
                         }
                         const allOptions = document.querySelectorAll('.browse-locations-popup__option');
                         allOptions.forEach(opt => opt.removeAttribute('data-selected'));

                         // Clear error message
                         zipError.style.display = 'none';

                         // Hide back button (in default state)
                         const backButton = document.querySelector('.browse-locations-popup__back-to-list');
                         if (backButton) {
                           backButton.style.display = 'none';
                            backButton.setAttribute('data-current-type', 'neither')

                         }

                         return;
                       }

                       // Clear any previous error
                        zipError.style.display = 'none';
                        zipButton.textContent = 'Searching...';
                        zipButton.style.padding = '12px 12px';
                        zipButton.disabled = true;

                       // Get coordinates from ZIP code
                       const coords = await getCoordinatesFromZip(zipCode);

                       if (!coords) {
                            zipError.textContent = 'Invalid ZIP code or ZIP code not found';
                            zipError.style.display = 'block';
                            zipButton.textContent = 'Search';
                            zipButton.style.padding = '12px 24px';
                            zipButton.disabled = false;
                            return;
                       }

                       // Find nearest 5 locations
                       const nearestLocations = findNearestLocations(coords.latitude, coords.longitude, showroomData, 5);

                       if (nearestLocations && nearestLocations.length > 0) {
                         // Build and display carousel
                         const carouselHTML = buildLocationsCarousel(nearestLocations, showroomData);
                         const contentContainer = document.querySelector('.browse-locations-popup__content-dynamic');
                         if (contentContainer) {
                           contentContainer.innerHTML = carouselHTML;
                         }

                         // Initialize swiper after content update
                         setTimeout(() => {
                           initLocationsSwiper();
                         }, 100);

                         // Hide dropdown when showing carousel
                         const dropdown = document.querySelector('.browse-locations-popup__dropdown');
                         if (dropdown) {
                           dropdown.style.display = 'none';
                         }

                         // Show ZIP search section
                         const zipSearch = document.querySelector('.browse-locations-popup__zip-search');
                         if (zipSearch) {
                            zipSearch.style.display = 'flex';
                            zipSearch.style.justifyContent = 'center';
                            zipSearch.querySelector('.browse-locations-popup__label').style.display = 'none';
                            zipSearch.querySelector('.browse-locations-popup__zip-input-container').style.justifyContent = 'center';
                         }

                         // Show success message
                         zipError.style.color = 'var(--primary-green)';
                         zipError.textContent = `Found ${nearestLocations.length} location${nearestLocations.length > 1 ? 's' : ''} near you`;
                         zipError.style.display = 'none';

                         // Clear dropdown selection
                         window.Branch.showroomBrowseLocations.selectedHandle = '';
                         if (selectTrigger) {
                           selectTrigger.querySelector('span').textContent = 'Location';
                           selectTrigger.setAttribute('data-current-value', '');
                         }
                         const allOptions = document.querySelectorAll('.browse-locations-popup__option');
                         allOptions.forEach(opt => opt.removeAttribute('data-selected'));

                         // Show back button (not in default state)
                         const backButton = document.querySelector('.browse-locations-popup__back-to-list');
                         if (backButton) {
                           backButton.style.display = 'block';
                            backButton.setAttribute('data-current-type', 'zipsearch')

                         }
                       } else {
                         zipError.textContent = 'No locations found';
                         zipError.style.display = 'block';
                       }

                        zipButton.textContent = 'Search';
                        zipButton.style.padding = '12px 24px';
                        zipButton.disabled = false;
                     };

                     zipButton.addEventListener('click', handleZipSearch);

                     // Allow Enter key to trigger search
                     zipInput.addEventListener('keypress', function(e) {
                       if (e.key === 'Enter') {
                         handleZipSearch();
                       }
                     });
                   }
                 }, 100);
               } else {
                 console.error('Simplistic.openModal is not available');
               }
             });
           }

        let browseLocationsResizeTimeout;
        window.addEventListener('resize', function() {
            clearTimeout(browseLocationsResizeTimeout);
            browseLocationsResizeTimeout = setTimeout(function() {
                resizeTileHeader();
            }, 250);
        });
    }    
  })();
